import { OptionProperty } from '@/ui-kit/components/form/controls/components/select/enums';
import { ListingBookViewingFormControlName } from '../enums';
import { DEFAULT_VIEWING_DURATION_IN_MINUTES } from '../../constants';

export const CONTACT_METHOD_OPTIONS = [
  {
    [OptionProperty.Label]: 'Email',
    [OptionProperty.Value]: 'Email',
  },
  {
    [OptionProperty.Label]: 'Phone call',
    [OptionProperty.Value]: 'Phone call',
  },
  {
    [OptionProperty.Label]: 'Text',
    [OptionProperty.Value]: 'Text',
  },
];
export const DURATION_OPTIONS = [
  {
    [OptionProperty.Label]: '1 hour',
    [OptionProperty.Value]: 60,
  },
  {
    [OptionProperty.Label]: '30 minutes',
    [OptionProperty.Value]: DEFAULT_VIEWING_DURATION_IN_MINUTES,
  },
];
export const LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE = {
  [ListingBookViewingFormControlName.Date]: '',
  [ListingBookViewingFormControlName.StartTime]: '',
  [ListingBookViewingFormControlName.Duration]: '',
  [ListingBookViewingFormControlName.AdditionalDate]: '',
  [ListingBookViewingFormControlName.AdditionalStartTime]: '',
  [ListingBookViewingFormControlName.AdditionalDuration]: '',
  [ListingBookViewingFormControlName.PhoneNumber]: '',
  [ListingBookViewingFormControlName.ContactMethod]: CONTACT_METHOD_OPTIONS[0].value,
};
